<template>
  <div class="page-container">
    <div class="header-box">
      <div class="nav-box">
        <button class="icon-back" @click="goback"></button>
        <div class="title">我的体验金</div>
        <router-link class="icon-home" to="/home"></router-link>
      </div>
      <div class="content">
        <div class="title">可使用体验金</div>
        <div class="money-box">
          <div class="left">
            <div class="money">{{ info.accountExperience }}</div>
            <div class="unit">元</div>
          </div>
          <div class="right">
            <button class="btn" @click="handleSend">转赠</button>
          </div>
        </div>
        <div class="tips">体验金仅用于购买「体验专区」商品</div>
      </div>
    </div>
    <van-tabs
      :border="false"
      :ellipsis="false"
      color="#D9A47B"
      line-height="0.08rem"
      line-width="0.46rem"
      sticky
      title-active-color="#D9A47B"
      title-inactive-color="#D9A47B"
    >
      <van-tab :key="index" :title="nav.title" class="nav-tab" v-for="(nav, index) in navList">
        <div class="nav-container">
          <component :is="nav.com"></component>
        </div>
      </van-tab>
    </van-tabs>

    <popup-message ref="PopupMessageRef">
      <template #title>转赠提醒</template>
      <template #content>
        <div class="give-content">
          <div style="text-align: center;margin-bottom: 0.30rem;">转赠成功后不可转回，请输入转赠金额</div>
          <form action="">
            <div class="form-item">
              <label for="">转赠金额</label>
              <input class="inp" v-model="formData.count" type="text" placeholder="请输入转赠金额">
            </div>
            <div class="form-item">
              <label for="">再次输入</label>
              <input class="inp" v-model="formData.countAgain" type="text" placeholder="请输入转赠金额">
            </div>
          </form>
          <div style="width: 4.10rem;float: right;">当前可转赠体验金 {{ info.accountExperience }}</div>
        </div>
      </template>
      <template #tips>提交转赠后，相应体验金将冻结不可使用，如撤销转赠，体验金将退回您的账户。</template>
    </popup-message>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { Tab, Tabs } from 'vant'
import ChargeRecords from './components/ChargeRecords.vue'
import UnavailableRecords from './components/UnavailableRecords.vue'
import PopupMessage from './components/PopupMessage.vue'

export default {
  name: 'ExperienceGold',
  components: {
    VanTab: Tab,
    VanTabs: Tabs,
    ChargeRecords,
    UnavailableRecords,
    PopupMessage
  },
  data () {
    return {
      info: {
        accountExperience: 0
      },
      formData: {
        count: '',
        countAgain: ''
      },
      navList: [
        { title: '体验金明细', name: 'UnavailableRecords', com: UnavailableRecords },
        { title: '转赠记录', name: 'ChargeRecords', com: ChargeRecords }
      ]
    }
  },
  computed: {
    ...mapState('store', ['rebateInfo'])
  },
  watch: {},
  created () {
    this.fetchInfo()
  },
  methods: {
    goback () {
      this.$router.back()
    },
    async fetchInfo () {
      const res = await this.$axios.get('api/member/account_experience')
      const { code, data } = res.data
      if (code === 0) {
        this.info.accountExperience = data.account_experience
      }
    },
    handleSend () {
      this.$refs.PopupMessageRef.open({
        cancelFn: (done) => {
          this.formData.count = ''
          this.formData.countAgain = ''
          done()
        },
        confirmFn: async (done) => {
          const validate = this.validateForm()
          if (validate) {
            await this.onSubmit()
          }
        }
      })
    },
    validateForm () {
      let result = false
      const count = this.formData.count * 1
      const countAgain = this.formData.countAgain * 1
      if (!count) {
        this.$toast('请输入转赠金额')
        return result
      }
      if (!countAgain) {
        this.$toast('请再次输入转赠金额')
        return result
      }
      if (count !== countAgain) {
        this.$toast('请确认两次输入金额')
        return result
      }
      result = true
      return result
    },
    async onSubmit () {
      this.$toast.loading()
      const payload = {
        rebate_count: this.formData.count
      }
      const res = await this.$axios.post('api/member/account_experience_gift_send', payload)
      this.$toast.clear()
      const { code, data, msg } = res.data
      if (code === 0) {
        this.$router.push({ name: 'EGDetail', query: { code: data, type: 1 } })
      } else {
        this.$toast(msg)
      }
    }
  }
}
</script>

<style lang="less" scoped>
@main_color: #D9A47B;
@tabs_height: 0.82rem;

* {
  box-sizing: border-box;
}

.page-container {
  .header-box {
    background-image: linear-gradient(180deg, #131625, #252A48);
    padding-bottom: @tabs_height;

    .nav-box {
      padding: 0.2rem 0.30rem 0.30rem;
      font-size: 0.28rem;
      color: @main_color;
      .flex-between;

      .icon-back,
      .icon-home {
        width: 0.6rem;
        height: 0.6rem;
        background: no-repeat  center / 100%;
      }
      .icon-back {
        background-image: url("./images/icon-arrow.png");
      }
      .icon-home {
        background-image: url("./images/icon-home.png");
      }
    }

    .content {
      padding: 0 0.30rem 0.25rem;
      color: @main_color;

      .title {
        font-size: 0.26rem;
      }

      .money-box {
        margin-top: 0.20rem;
        color: @main_color;
        .flex-between;

        .left {
          display: flex;
          align-items: flex-end;
          .money {
            font-size: 0.88rem;
            font-weight: bold;
          }
          .unit {
            padding: 0 0 0.10rem 0.14rem;
            font-size: 0.28rem;
          }
        }
        .right {
          .btn {
            width: 1.84rem;
            height: 0.72rem;
            border: 0.02rem solid @main_color;
            border-radius: 999rem;
            font-size: 0.26rem;
            color: @main_color;
            .flex-center;
          }
        }
      }
      .tips {
        margin-top: 0.20rem;
        font-size: 0.22rem;
        color: #A48268;
      }
    }
  }
  /deep/ .van-tabs__wrap {
    height: @tabs_height;
    margin-top: -@tabs_height;

    .van-tabs__nav {
      background: transparent !important;
      border: 0.02rem solid rgba(210, 160, 121, 0.4) !important;
    }
    .van-tabs__line {
      border-radius: initial !important;
    }
  }
}
.give-content {
  width: 100%;
  margin: 0.06rem 0 0.18rem;
  font-size: 0.22rem;
  color: #545454;
  .form-item {
    margin-bottom: 0.25rem;
    .flex-between;

    .inp {
      width: 4.10rem;
      height: 0.54rem;
      background: #FFFFFF;
      padding: 0 0.16rem;
      border-radius: 0.10rem;
      border: 0.01rem solid #979797;
      &::placeholder {
        font-size: 0.22rem;
        color: #B1B1B1;
      }
    }
  }
}
</style>
